const Loader = () => {
  return (
    <div className={'ptm-lds-ring'}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./components/loader/index.js